import {
    Box,
    Flex,
    useColorModeValue,
    Drawer,
    DrawerContent,
    useDisclosure,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

import { Sidebar, SidebarContent } from './Sidebar';
import { Header } from './Header';

interface DashboardLayoutProps {
    children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const bgVal = useColorModeValue('gray.50', 'navy.900');

    return (
        <Flex minH="100vh" bg={bgVal}>
            {/* Desktop Sidebar */}
            <Sidebar />

            {/* Mobile Drawer */}
            <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                size="xs"
            >
                <DrawerContent bg={bgVal}>
                    <SidebarContent onClose={onClose} w="full" borderRight="none" />
                </DrawerContent>
            </Drawer>

            <Box flex="1" ml={{ base: 0, md: '280px' }} w={{ base: '100%', md: 'calc(100% - 280px)' }} overflowX="hidden">
                <Header onOpen={onOpen} />
                <Box as="main" p={{ base: 3, md: 6 }} minH="calc(100vh - 80px)" overflowX="hidden">
                    {children}
                </Box>
            </Box>
        </Flex>
    );
}
